import React, { createContext, useState } from "react";
export const StepsContext = createContext(null);
export const StepsProvider = ({ children = void 0 }) => {
  const [currentStep, setCurrentStep] = useState("authorize");
  const [enabledSteps, enableStep] = useState(["authorize"]);
  const [availableSteps, setAvailableStep] = useState([]);
  const isDisabledStep = (step) => {
    if (!enabledSteps || enabledSteps.length === 0) {
      return true;
    }
    return !enabledSteps.includes(step);
  };
  const setEnabledStep = (step) => {
    enableStep([...enabledSteps, step]);
  };
  return /* @__PURE__ */ React.createElement(
    StepsContext.Provider,
    {
      value: {
        availableSteps,
        currentStep,
        enabledSteps,
        isDisabledStep,
        setAvailableStep,
        setCurrentStep,
        setEnabledStep
      }
    },
    children
  );
};
